import React from 'react';
import { Timeline, Typography } from 'antd';
import type { RevisionHistoryItem } from '../types';

const { Text } = Typography;

function formatDate(s: string): string {
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}/${m}/${day}`;
  } catch {
    return s;
  }
}

function relativeTime(s: string): string {
  const now = Date.now();
  const then = new Date(s).getTime();
  const diffMs = now - then;
  if (Number.isNaN(diffMs)) return '';
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(s);
}

function formatDateTimeFull(s: string): string {
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const h = d.getHours() % 12 || 12;
    const min = String(d.getMinutes()).padStart(2, '0');
    const ampm = d.getHours() < 12 ? 'AM' : 'PM';
    return `${y}/${m}/${day} ${String(h).padStart(2, '0')}:${min} ${ampm}`;
  } catch {
    return s;
  }
}

export interface RevisionHistoryTimelineProps {
  items: RevisionHistoryItem[];
}

export const RevisionHistoryTimeline: React.FC<RevisionHistoryTimelineProps> = ({ items }) => {
  if (items.length === 0) {
    return <Text type="secondary">No revisions requested yet.</Text>;
  }

  return (
    <Timeline
      items={items.map((item) => ({
        color: 'orange',
        children: (
          <div>
            <div>
              <Text>{item.note}</Text>
            </div>
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {item.requestedByDisplayName || 'Unknown'} &middot;{' '}
                <span title={formatDateTimeFull(item.requestedAtUtc)}>
                  {relativeTime(item.requestedAtUtc)}
                </span>
              </Text>
            </div>
          </div>
        ),
      }))}
    />
  );
};
